class auth {
    isAuthenticated() {
        try {
            var user = JSON.parse(localStorage.getItem('user'))
            return (user === null || user.nombre === undefined) ? false : true;
        } catch (error) {
            return false;
        }
    };

    user() {
        const data = JSON.parse(localStorage.getItem('user'));
        return data;
    }
}
export default new auth();